import { render, staticRenderFns } from "./SettingsTagColors.vue?vue&type=template&id=30462982"
import script from "./SettingsTagColors.vue?vue&type=script&lang=js"
export * from "./SettingsTagColors.vue?vue&type=script&lang=js"
import style0 from "./SettingsTagColors.vue?vue&type=style&index=0&id=30462982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports